/**
 * Pronto Posto – Maildaten · Deutsch (de-DE) · KS02
 *
 * KS02 – Novak / Gussmann / Rossi. Postfächer: marc.novak@, francesca.amore@pronto-posto.com
 *
 * Aufteilung nach language/episode: geteilte Inhalte einer Sprache leben in ./_shared.js.
 * Sprachen sind strikt getrennt – Mails dieser Datei adressieren ausschliesslich Postfaecher
 * dieser Sprache. IDs sind global eindeutig (siehe ID-Reservierungen in den Blockkommentaren).
 */
/* eslint-disable */

export function getEmails() {
    const email_password_rossi = window.localStorage.getItem('marc.novak')

    return [
        // novak-gussmann mails
        {
            id: 1,
            from: {
                email: 'rambo15@pronto-posto.com',
                name: 'Unbekannt',
                avatar: require('@src/assets/images/portrait/gussmann.jpg').default
            },
            to: [{
                name: 'Marc Novak',
                email: 'marc.novak@pronto-posto.com'
            }],
            subject: 'Versteck',
            cc: [],
            bcc: [],
            message: '<p>Ich hab die Beute wie besprochen vergraben.</p><p>Schau mal im Anhang.</p>',
            attachments: [
                {
                    fileName: 'tattoo_entwurf.jpg',
                    thumbnail: require('@src/assets/images/icons/jpg.png').default,
                    url: 'https://storage.googleapis.com/cc-pronto-posto/ks02_tattoo_entwurf.jpg',
                    size: '273kb',
                    password: 'johnsdiner'
                },
            ],
            isStarred: false,
            labels: ['personal'],
            time: 'Do. Apr. 07 2022 07:45:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: true
        },
        {
            id: 3,
            from: {
                email: 'rambo15@pronto-posto.com',
                name: 'Unbekannt',
                avatar: require('@src/assets/images/portrait/gussmann.jpg').default
            },
            to: [{
                name: 'Marc Novak',
                email: 'marc.novak@pronto-posto.com'
            }],
            subject: 'RE: Versteck',
            cc: [],
            bcc: [],
            message: 'Junge das hatten wir doch besprochen! Hinweis: Dein Lieblingsort.',
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Do. Apr. 07 2022 09:03:00 GMT+0000 (GMT)',
            replies: [
                {
                    id: 2,
                    from: {
                        email: 'marc.novak@pronto-posto.com',
                        name: 'Marc Novak',
                        avatar: require('@src/assets/images/portrait/novak.jpg').default
                    },
                    to: [{
                        name: 'Unbekannt',
                        email: 'rambo15@pronto-posto.com'
                    }],
                    subject: 'RE: Versteck',
                    cc: [],
                    bcc: [],
                    message: 'Sehr gut. Aber das ist passwortgeschützt ich kann es nicht öffnen!!',
                    attachments: [],
                    isStarred: false,
                    labels: ['personal'],
                    time: 'Do. Apr. 07 2022 09:56:00 GMT+0000 (GMT)',
                    replies: [],
                    folder: 'sent',
                    isRead: true
                },
            ],
            folder: 'inbox',
            isRead: true
        },
        {
            id: 4,
            from: {
                email: 'rambo15@pronto-posto.com',
                name: 'Unbekannt',
                avatar: require('@src/assets/images/portrait/gussmann.jpg').default
            },
            to: [{
                name: 'Marc Novak',
                email: 'marc.novak@pronto-posto.com'
            }],
            subject: 'Probleme',
            cc: [],
            bcc: [],
            message: 'Mist wir sind kurz vorm auffliegen!! Habe in der Zeitung gelesen, dass jemand deine Stimme erkannt hat',
            attachments: [],
            isStarred: true,
            labels: ['personal'],
            time: 'Fr. Apr. 08 2022 12:23:00 GMT+0000 (GMT)',
            replies: [
                {
                    id: 7,
                    from: {
                        email: 'marc.novak@pronto-posto.com',
                        name: 'Marc Novak',
                        avatar: require('@src/assets/images/portrait/novak.jpg').default
                    },
                    to: [{
                        name: 'Unbekannt',
                        email: 'rambo15@pronto-posto.com'
                    }],
                    subject: 'RE: Probleme',
                    cc: [],
                    bcc: [],
                    message: 'Ganz ruhig. Habe jetzt auch den Artikel gelesen. Ist alles halb so wild. Der weiß ja garnicht wer ich bin',
                    attachments: [],
                    isStarred: false,
                    labels: ['personal'],
                    time: 'Fr. Apr. 08 2022 15:48:00 GMT+0000 (GMT)',
                    replies: [],
                    folder: 'sent',
                    isRead: true
                },
                {
                    id: 6,
                    from: {
                        email: 'rambo15@pronto-posto.com',
                        name: 'Unbekannt',
                        avatar: require('@src/assets/images/portrait/gussmann.jpg').default
                    },
                    to: [{
                        name: 'Marc Novak',
                        email: 'marc.novak@pronto-posto.com'
                    }],
                    subject: 'RE: RE: RE: RE: Versteck',
                    cc: [],
                    bcc: [],
                    message: 'Plan B, Ich tauch erstmal unter! Lassen wir ein bisschen Gras über die Sache wachsen. Schön Zuhause bleiben und nicht auffallen! Hoffentlich reicht das... ich werd nervös bei sowas',
                    attachments: [],
                    isStarred: false,
                    labels: ['personal'],
                    time: 'Fr. Apr. 08 2022 15:06:00 GMT+0000 (GMT)',
                    replies: [
                        {
                            id: 5,
                            from: {
                                email: 'marc.novak@pronto-posto.com',
                                name: 'Marc Novak',
                                avatar: require('@src/assets/images/portrait/novak.jpg').default
                            },
                            to: [{
                                name: 'Unbekannt',
                                email: 'rambo15@pronto-posto.com'
                            }],
                            subject: 'RE: RE: RE: Versteck',
                            cc: [],
                            bcc: [],
                            message: 'Scheibenkleister! Was machen wir jetzt?',
                            attachments: [],
                            isStarred: false,
                            labels: ['personal'],
                            time: 'Fr. Apr. 08 2022 14:16:00 GMT+0000 (GMT)',
                            replies: [],
                            folder: 'inbox',
                            isRead: true
                        },
                    ],
                    folder: 'inbox',
                    isRead: true
                },
            ],
            folder: 'inbox',
            isRead: true
        },
        {
            id: 9,
            from: {
                email: 'rambo15@pronto-posto.com',
                name: 'Unbekannt',
                avatar: require('@src/assets/images/portrait/gussmann.jpg').default
            },
            to: [{
                name: 'Marc Novak',
                email: 'marc.novak@pronto-posto.com'
            }],
            subject: 'RE: Telefonieren',
            cc: [],
            bcc: [],
            message: '<p>Okay.</p>',
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Do. Apr. 14 2022 13:22:00 GMT+0000 (GMT)',
            replies: [
                {
                    id: 8,
                    from: {
                        email: 'marc.novak@pronto-posto.com',
                        name: 'Marc Novak',
                        avatar: require('@src/assets/images/portrait/novak.jpg').default
                    },
                    to: [{
                        name: 'Unbekannt',
                        email: 'rambo15@pronto-posto.com'
                    }],
                    subject: 'RE: RE: RE: RE: RE: RE: Versteck',
                    cc: [],
                    bcc: [],
                    message: 'Lass uns kurz telefonieren... es haben sich ein paar Komplikationen ergeben! Aber versprich mir dass du nichts dummes machst!',
                    attachments: [],
                    isStarred: false,
                    labels: ['personal'],
                    time: 'Do. Apr. 14 2022 13:22:00 GMT+0000 (GMT)',
                    replies: [],
                    folder: 'inbox',
                    isRead: true
                }
            ],
            folder: 'inbox',
            isRead: true
        },
        // rossi-novak mails
        {
            id: 11,
            from: {
                email: 'marc.novak@pronto-posto.com',
                name: 'Marc Novak',
                avatar: require('@src/assets/images/portrait/novak.jpg').default
            },
            to: [{
                name: 'Francesca Rossi',
                email: 'francesca.amore@pronto-posto.com'
            }],
            subject: 'RE: :*',
            cc: [],
            bcc: [],
            message: '<p>Ja ja. Irgendwann kommt unsere Beziehung doch sowieso raus. Aber das ist egal.</p><p>Ich liebe dich ' + email_password_rossi + ' mal :*</p>',
            attachments: [],
            isStarred: true,
            labels: ['personal'],
            time: 'Sa. Apr. 02 2022 18:19:00 GMT+0000 (GMT)',
            replies: [
                {
                    id: 10,
                    from: {
                        name: 'Francesca Rossi',
                        email: 'francesca.amore@pronto-posto.com',
                        avatar: require('@src/assets/images/portrait/rossi.jpg').default
                    },
                    to: [{
                        email: 'marc.novak@pronto-posto.com',
                        name: 'Marc Novak',
                    }],
                    subject: ':*',
                    cc: [],
                    bcc: [],
                    message: 'Wir müssen mehr aufpassen! Gestern hätte uns fast dieser Reporter von News Flash erwischt.',
                    attachments: [],
                    isStarred: true,
                    labels: ['personal'],
                    time: 'Sa. Apr. 02 2022 18:19:00 GMT+0000 (GMT)',
                    replies: [],
                    folder: 'inbox',
                    isRead: true
                },
            ],
            folder: 'inbox',
            isRead: true
        },
        {
            id: 13,
            from: {
                email: 'marc.novak@pronto-posto.com',
                name: 'Marc Novak',
                avatar: require('@src/assets/images/portrait/novak.jpg').default
            },
            to: [{
                name: 'Francesca Rossi',
                email: 'francesca.amore@pronto-posto.com'
            }],
            subject: 'RE: RE: :*',
            cc: [],
            bcc: [],
            message: 'Ist ja auch meine Lieblingszahl. Die bringt mir Glück!',
            attachments: [],
            isStarred: true,
            labels: ['personal'],
            time: 'Sa. Apr. 02 2022 18:55:00 GMT+0000 (GMT)',
            replies: [
                {
                    id: 12,
                    from: {
                        email: 'francesca.amore@pronto-posto.com',
                        name: 'Francesca Rossi',
                        avatar: require('@src/assets/images/portrait/rossi.jpg').default
                    },
                    to: [{
                        name: 'Marc Novak',
                        email: 'marc.novak@pronto-posto.com'
                    }],
                    subject: 'RE: RE: :*',
                    cc: [],
                    bcc: [],
                    message: 'Das ist aber ganz schön oft :D',
                    attachments: [],
                    isStarred: false,
                    labels: ['personal'],
                    time: 'Sa. Apr. 02 2022 18:36:00 GMT+0000 (GMT)',
                    replies: [],
                    folder: 'sent',
                    isRead: true
                },
            ],
            folder: 'inbox',
            isRead: true
        },
        {
            id: 14,
            from: {
                email: 'noreply@filebox.posto-pronto.com',
                name: 'Filebox',
                avatar: require('@src/assets/images/portrait/filebox.jpeg').default
            },
            to: [{
                name: 'Francesca Rossi',
                email: 'francesca.amore@pronto-posto.com'
            }],
            subject: 'Ein Ordner wurde mit Ihnen geteilt',
            cc: [],
            bcc: [],
            message: '<p>J. Seeholz hat den Ordner filebox/Rossi/RosesofSadness/ mit Ihnen geteilt.</p><p>Klicken sie hier um zum Ordner zu gelangen: <a href="https://filebox.pronto-posto.com/seeholz-music-backup-server/" target="_blank">https://filebox.pronto-posto.com/seeholz-music-backup-server/</a></p><p>Ihr Filebox Team</p>',
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Sa. Apr. 16 2022 16:34:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: true
        },
    ]
}

export function getSpam() {
    return [
        // rossi and novak spam mails
        {
            id: 100,
            from: {
                email: 'schnaeppchen@schoko-laden.net',
                name: 'Schoko-Laden.net',
                avatar: require('@src/assets/images/portrait/chocolate.jpeg').default
            },
            to: [{
                name: 'Marc Novak',
                email: 'marc.novak@pronto-posto.com'
            }, {
                name: 'Francesca Rossi',
                email: 'francesca.amore@pronto-posto.com'
            },
            ],
            subject: 'Schokoschnäppchen Häppchen für dich!',
            cc: [],
            bcc: [],
            message: '<p>+++Nur noch 6 Monate bis Weihnachten!+++</p> <p>Deck dich jetzt mit unseren einzigarten Fabrikverkaufsproben ein!<p> </p><p>Frisch von Fließband direkt auf deine Zunge! Mit dem Code "Sommerloch10" bekommst du 10% Rabatt auf alle Produkte!</p> <p>Worauf wartest du noch?</p>',
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Do. Jun. 03 2022 02:10:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        },
        {
            id: 101,
            from: {
                email: 'support@crime-cases.de',
                name: 'Crime Cases',
                avatar: require('@src/assets/images/portrait/CrimeCases.png').default
            },
            to: [{
                name: 'Marc Novak',
                email: 'marc.novak@pronto-posto.com'
            }, {
                name: 'Francesca Rossi',
                email: 'francesca.amore@pronto-posto.com'
            },
            {
                name: 'Maximilian Lange',
                email: 'm.lange@pronto-posto.com'
            },
            ],
            subject: 'Dein neuer Job?',
            cc: [],
            bcc: [],
            message: '<p>Du bist ein Fan von Rätseln und Detektiv Spielen? 🕵🏼‍♂️</p> <p>Du hast Erfahrung in Story Writing ✍️, Design 🧑‍🎨, Projektmanagement 🗓️ und/oder Web Development 🧑‍💻?<p> <p>Dann melde dich bei uns, wir freuen uns dich kennenzulernen!</p> <p>Überrasche uns mit einer kreativen Bewerbung, die du an <a href = "mailto: support@crime-cases.de">support@crime-cases.de</a> sendest!</p>',
            attachments: [],
            isStarred: false,
            labels: ['company'],
            time: 'Do. Jan. 11 2022 10:10:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        },
        // rossi spam mails
        {
            id: 102,
            from: {
                email: 'shipping@spiele-versand-24.com',
                name: 'Spiele Versand',
                avatar: require('@src/assets/images/portrait/board-games.png').default
            },
            to: [{
                    name: 'Francesca Rossi',
                    email: 'francesca.amore@pronto-posto.com'
                },
            ],
            subject: 'Ihre Bestellung wurde versendet',
            cc: [],
            bcc: [],
            message: '<h2>Versandbestätigung </h2><br><p>Ihre Bestellung "Akte 001 Kunstfehler" wurde versendet. </p><p>Geschätzte Versanddauer: 3 Tage</p><br><p>Ihr Spieleversand 24 Team</p>',
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Do. Apr. 01 2022 09:45:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: true
        },
        {
            id: 103,
            from: {
                email: 'angela@astro-horoskop-24.de',
                name: 'Dein Horoskop Angela',
                avatar: require('@src/assets/images/portrait/angela-horoskop.jpeg').default
            },
            to: [{
                name: 'Francesca Rossi',
                email: 'francesca.amore@pronto-posto.com'
            },
            ],
            subject: 'Dein Schicksal steht unter keinem guten Stern...',
            cc: [],
            bcc: [],
            message: '<h3>Huhu meine Liebe, hier kommt dein monatliches Liebeshoroskop ❤️ </h3><br><p>In der Liebe neigt der Stier zur sinnlichen Aufopferungsbereitschaft🙏🏼.</p><p>Jedoch nicht in jeder Paarung der Sternzeichen✨. Denn obwohl er so bereitwillig alles für eine harmonische Liebesbeziehung tun wird, lässt er sich von anderen Sternzeichen nicht den Sinn für das Schöne ausreden oder gar hintergehen 🙅‍♀️.</p><p>Doch er lebt auch in Angst, denn gerade in der Liebe können so viele unvorhergesehene Dinge passieren 😨, mit denen er aber aufgrund seiner Wesenszüge Probleme hat 😤. Er braucht die schöne heile Welt, in der er die Übersicht behalten kann 🥰.</p><br><p>Ich hoffe das hilft dir! Ich spüre keine guten Schwingungen bei dir aktuell!</p><br><h3>Bis bald meine Süße, deine Angela! ❤️🙏🏼❤️</h3>',
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Do. Apr. 02 2022 18:45:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: true
        },
        // novak spam mails
        {
            id: 104,
            from: {
                email: 'mcr@geldschrank-vertriebs-gmbh.de',
                name: 'MCR Geldschrank Vertriebs GmbH Berlin',
                avatar: require('@src/assets/images/portrait/key.png').default
            },
            to: [{
                name: 'Marc Novak',
                email: 'marc.novak@pronto-posto.com'
            }],
            subject: 'Warnung vor der Kuchenblech Mafia',
            cc: [],
            bcc: [],
            message: '<h1><span style="color:red">Aufgebrochene Geldschränke säumen Deutschlands Straßen.</h1></span><p>Vertrauen Sie nicht der Konkurrenz. Deren Tresore sind weich wie Schuhkarton! <p></p><p>Nur unsere Produkte sind keine Sardinenbüchsen.</p><br><p>Jeden Tag liegt ein neuer Schrank am Boden, <b><span style="color:red">Ihrer könnte der nächste sein.</span></b></p><p>Handeln Sie jetzt und konktaktieren Sie unseren <b>Vertrieb!</b></p>',
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Do. Apr. 10 2022 04:45:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        },
        {
            id: 105,
            from: {
                email: 'xxx@tough-love.de',
                name: 'Tough Love Mobile Dating',
                avatar: require('@src/assets/images/portrait/lips.jpeg').default
            },
            to: [{
                name: 'Marc Novak',
                email: 'marc.novak@pronto-posto.com'
            }],
            subject: 'Frauen aus Gretenburg wollen dich kennenlernen',
            cc: [],
            bcc: [],
            message: '<p>Marc, </p><p>worauf wartest du noch? Attraktive Frauen aus Gretenburg wollen dich kennenlernen! Bist du bereit für ein Abenteuer? Einen kleinen Seitensprung? Hol dir unsere App und erkunde deine wildesten Fantasien, du willst es doch auch!</p>',
            attachments: [],
            isStarred: true,
            labels: ['private'],
            time: 'Do. Mar. 27 2022 11:27:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: true
        },
        {
            id: 106,
            from: {
                email: 'support@a12.paiipal.com',
                name: 'Paypal SUPPORT',
                avatar: require('@src/assets/images/portrait/blue-p-logo.jpeg').default
            },
            to: [{
                name: 'Marc Novak',
                email: 'marc.novak@pronto-posto.com'
            }],
            subject: 'BEDEUTEND NACHRIHT - BITTE GLECIH ZU LESEN DIES, MEINE GESCHAZTER FREUND!!!!!!!',
            cc: [],
            bcc: [],
            message: '<p>Ich bin mit diesem Medium, um Sie über die Transaktion zur Abgabe von $ 21500000 (Einundzwanzig Millionen fünfhunderttausend Euro) in meiner Bank in China, Sie als Empfänger zu informieren. Es wird zu 100% sicher, dass der Finanzvorstand des verstorbenen Kunden.</p><p>Bitte auf meine private E-Mail kontaktieren unter für Fragen und weitere Informationen Mit freundlichen Grüßen,</p><p>sang Chin</p>',
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Do. Apr. 07 2022 11:10:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: true
        },
    ]
}
